import { FetchProvincesCommand } from './FetchProvincesCommand'
import { ProvinceDto } from './ProvinceDto'
import { ProvinceRepository } from '@/Domain/Localization/Province'

export class FetchProvincesCommandHandler {
  private _repository: ProvinceRepository

  constructor (repository: ProvinceRepository) {
    this._repository = repository
  }

  // eslint-disable-next-line
  async handle (command: FetchProvincesCommand): Promise<ProvinceDto[]> {
    const provinces = await this._repository.findAll()
    const response: ProvinceDto[] = []
    for (const province of provinces) {
      const item = ProvinceDto.fromProvince(province)
      response.push(item)
    }
    return response
  }
}
